import { render, staticRenderFns } from "./ShowAll.vue?vue&type=template&id=552a227a&scoped=true"
import script from "./ShowAll.vue?vue&type=script&lang=js"
export * from "./ShowAll.vue?vue&type=script&lang=js"
import style0 from "./ShowAll.vue?vue&type=style&index=0&id=552a227a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552a227a",
  null
  
)

export default component.exports